import { css } from "styled-components";

const HIDE_COMPONENT_OFFSET_TOP = 300;

const TRANSITION_IN_FUNCTION = "cubic-bezier(0.1, 0.7, 0.6, 1)";
const TRANSITION_OUT_FUNCTION = "linear";
const TRANSITION_DURATION = 400;

export const commonStylesForHideTopNav = css`
  transition-property: top;
  transition-duration: ${TRANSITION_DURATION}ms;
`;

// We need to inline this to avoid the entire styled component being recalculated, causing flickers and other unwanted side effects
export const inlineTransitionStylesForHideTopNav = (
  shouldRetainOriginalPosition: boolean = true,
  topOffset: number = 0,
  hideComponentOffsetTop: number = HIDE_COMPONENT_OFFSET_TOP
): React.CSSProperties => ({
  top: shouldRetainOriginalPosition
    ? topOffset
    : `-${hideComponentOffsetTop}px`,
  transitionDuration: `${
    (hideComponentOffsetTop / HIDE_COMPONENT_OFFSET_TOP) * 400
  }ms`,
  transitionTimingFunction: shouldRetainOriginalPosition
    ? TRANSITION_IN_FUNCTION
    : TRANSITION_OUT_FUNCTION,
});
